import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import API_URL from "../../config/ApiUrl";
import axios from "axios";

export const updateBackOfficeUserPassword = createAsyncThunk(
    "User/post",
    async (payload, { rejectWithValue }) => {
      try {
        const { data } = await axios.post(`${API_URL.USER.PASSWORD_RESET}`, payload);
        return data.data;
      } catch (error) {
        return rejectWithValue(error.data);
      }
    }
  );

const passwordSlice = createSlice({
  name: "password",
  initialState: {
    user_list: [],
    current_values: null,
    active_payload: null,
  },
  reducers: {
    setCurrentValues(state, action) {
      state.current_values = action.payload;
      console.log(state.current_values)
    },
    setActivePayload(state, action) {
      state.active_payload = action.payload;
    },
    resetCurrentValue(state) {
      state.current_values = null;
    },
  },
});

export const { setCurrentValues, setActivePayload, resetCurrentValue } =
  passwordSlice.actions;
export default passwordSlice.reducer;